import { FormEvent, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../../api/client';
import { Alert } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';

export function ResendVerificationPage() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get('email') ?? '');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setMessage('');
    setLoading(true);
    try {
      const result = await api.post<{ message: string }>('/api/account/resend-verification', {
        email,
      });
      setMessage(result.message);
    } catch (err) {
      setMessage(err instanceof Error ? err.message : 'No se pudo reenviar el correo');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Reenviar correo de verificación</h1>
        <p className="muted">
          Si tu cuenta aún no está verificada, te enviaremos un nuevo enlace de activación.
        </p>
        {message ? (
          <div style={{ marginTop: '1rem' }}>
            <Alert tone="success">{message}</Alert>
          </div>
        ) : null}
        <form method="post" action="/reenviar-verificacion" autoComplete="on" onSubmit={handleSubmit}>
          <Input
            label="Email"
            id="email"
            name="email"
            type="email"
            inputMode="email"
            autoComplete="email"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button type="submit" loading={loading}>
            Reenviar correo
          </Button>
        </form>
        <p className="auth-card__footer">
          <Link to="/login">Volver al login</Link>
        </p>
      </div>
    </div>
  );
}
